import { useTranslation } from 'react-i18next';
import PromoCarouselBlock from '../PromoCarouselBlock/PromoCarouselBlock';
import { openPromoModal } from 'Utils/modals';
import { EPromoSlugs } from 'Types/globals';
import { useDispatch } from 'react-redux';
import { PATHS } from 'Libraries/routes.library';
import { useRouter } from 'next/router';
import PromoPrimaryButton from '../PromoPrimaryButton/PromoPrimaryButton';
import PromoSecondaryButton from '../PromoSecondaryButton/PromoSecondaryButton';
import PromoImage from '../PromoImage/PromoImage';
import PromoBlock from '../PromoCarouselBlock/elements/PromoBlock/PromoBlock';
import PromoBlockButtons from '../PromoCarouselBlock/elements/PromoBlockButtons/PromoBlockButtons';
import PromoBlockContent from '../PromoCarouselBlock/elements/PromoBlockContent/PromoBlockContent';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

const PromoCarouselBlocks = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showRegisterButton = useShowAuthButtons();

  return (
    <PromoCarouselBlock>
      <PromoBlock title={t('homepage.c2.promo.cashback.title')} subtitle={t('homepage.c2.promo.cashback.subtitle')}>
        <PromoBlockButtons>
          {showRegisterButton ? 
            <PromoPrimaryButton
              href={{
                pathname: PATHS.REGISTER,
                query: {
                  ...router.query,
                },
              }}
              dataQa="button-promo-block-register"
            >
              {t('homepage.c2.promo.btn.play')}
            </PromoPrimaryButton>
          : null}
          <PromoSecondaryButton
            onClick={() => {
              openPromoModal(EPromoSlugs.CASHBACK, dispatch);
            }}
          >
            {t('homepage.c2.promo.btn.more')}
          </PromoSecondaryButton>
        </PromoBlockButtons>
        <PromoBlockContent>
          <PromoImage src="/images/homepage-c/cashback-promo.webp" alt="" />
        </PromoBlockContent>
      </PromoBlock>
      <PromoBlock title={t('homepage.b2.promo.1.title')} subtitle={t('homepage.b2.promo.1.description')}>
        {showRegisterButton ? 
          <PromoBlockButtons>
            <PromoPrimaryButton
              href={{
                pathname: PATHS.REGISTER,
                query: {
                  ...router.query,
                },
              }}
              dataQa="button-promo-block-register"
            >
              {t('homepage.c2.promo.btn.play')}
            </PromoPrimaryButton>
            <PromoSecondaryButton
              onClick={() => {
                openPromoModal(EPromoSlugs.RELOAD, dispatch);
              }}
            >
              {t('homepage.b2.promo.1.btn')}
            </PromoSecondaryButton>
          </PromoBlockButtons>
        : null}
        <PromoBlockContent>
          <PromoImage src="/images/homepage-c/recharge.webp" alt="" />
        </PromoBlockContent>
      </PromoBlock>
      <PromoBlock title={t('homepage.b2.promo.3.title')} subtitle={t('homepage.b2.promo.3.description')}>
        <PromoBlockButtons>
          {showRegisterButton ? 
            <PromoPrimaryButton
              href={{
                pathname: PATHS.REGISTER,
                query: {
                  ...router.query,
                },
              }}
              dataQa="button-promo-block-register"
            >
              {t('homepage.c2.promo.btn.play')}
            </PromoPrimaryButton>
          : null }
          <PromoSecondaryButton
            onClick={() => {
              openPromoModal(EPromoSlugs.LOYALTY, dispatch);
            }}
          >
            {t('homepage.b2.promo.3.btn')}
          </PromoSecondaryButton>
        </PromoBlockButtons>
        <PromoBlockContent>
          <PromoImage src="/images/homepage-c/loyalty.webp" alt="" />
        </PromoBlockContent>
      </PromoBlock>
    </PromoCarouselBlock>
  );
};

export default PromoCarouselBlocks;
